import { render, staticRenderFns } from "./NewProfileView.vue?vue&type=template&id=0b3785a4&scoped=true&"
import script from "./NewProfileView.vue?vue&type=script&lang=ts&"
export * from "./NewProfileView.vue?vue&type=script&lang=ts&"
import style0 from "./NewProfileView.vue?vue&type=style&index=0&id=0b3785a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3785a4",
  null
  
)

export default component.exports